import * as Sentry from '@sentry/react'

import { api } from './_init'
import { LOADING, UPDATE, OVERWRITE, FAIL } from '../reducers/default'
import { parseSetupProcess } from './models'

export async function fetchSetupProcess(dispatch, eventId) {
    dispatch({ type: LOADING })
    
    if (eventId) {
        try {
            const result = await api.get(`/setup_processes/${eventId}`)
            dispatch({ type: UPDATE, payload: parseSetupProcess(result.data) })
        } catch (error) {
            if (error.response?.status === 404)
                dispatch({ type: OVERWRITE, payload: { empty: true } })
            else
                dispatch({ type: FAIL })
        }
    }
}

export async function createSetupProcess (
    eventId,
    payload
) {
    if (eventId) {
        try {
            const result = await api.post(
                `/setup_processes/${eventId}`,
                payload,
            )
            return {
                setup: parseSetupProcess(result.data),
            }
        } catch (error) {
            return {
                error: 'common.errors.inServerResponse',
            }
        }
    }
}

export async function updateSetupProcess (
    dispatch,
    eventId,
    { total_budget, goal, creatives, conversion_id, integration_details, start_date, end_date }
) {
    dispatch({ type: LOADING })

    if (eventId) {
        try {
            const result = await api.put(
                `/setup_processes/${eventId}`,
                { total_budget, goal, creatives, conversion_id, integration_details, start_date, end_date }
            )
            dispatch({ type: OVERWRITE, payload: parseSetupProcess(result.data) })
        } catch (error) {
            dispatch({ type: FAIL, payload: 'common.errors.inServerResponse' })
        }
    }
}

export const deleteSetupProcess = async (dispatch, eventId, cancel = true) => {
    dispatch({ type: LOADING })
    if (eventId) {
        try {
            await api.delete(`/setup_processes/${eventId}?cancel=${cancel}`)
            dispatch({ type: OVERWRITE, payload: { cancelled: true } })
        } catch (error) {
            dispatch({ type: FAIL, payload: 'common.errors.inServerResponse' })
        }
    }
}

export const boostSetupProcess = async (dispatch, eventId) => {
    dispatch({ type: LOADING })
    if (eventId) {
        try {
            await api.post(`/setup_processes/${eventId}/boost`)
            dispatch({ type: OVERWRITE, payload: {} })
        } catch (error) {
            dispatch({ type: FAIL, payload: 'common.errors.inServerResponse' })
        }
    }
}

export async function fetchGeneratedCreativesAsync({
    eventId,
    tc,
    tcRunId,
    creativeFieldName,
    language,
    requiredNumberOfCreatives = 3,
}, controller = null
) {
    const params = {
        event_id: eventId,
        tc,
        tc_run_id: tcRunId,
        creatives_type: creativeFieldName,
        required_number_of_creatives: requiredNumberOfCreatives,
        language,
    }

    try {
        const result = await api.get(
            '/integrations/openai/gpt-3.5/generate_creatives',
            { params, signal: controller?.signal }
        )

        return {
            results: result.data,
            success: result.status === 200,
        }
    } catch (e) {
        Sentry.captureException(e)
        return { success: false }
    }
}

